<template>
    <div>
        <navbar></navbar>
        <div class="shop">
            <h1>{{shop.name}}</h1>
            <div class="shop-map">
                <div class="shop-desc">
                    <div class="banner">
                        <img :src="shop.img" width="90%">
                    </div>
                    <div class="address">
                        <h3>{{$t('add_address_address')}}:</h3>
                        <p>{{shop.address}}</p>
                        <p>{{shop.num}}</p>
                    </div>
                    <div class="business-hours">
                        <h3>{{$t('office_hours')}}:</h3>
                        <p class="time">
                            <label>{{$t('monday_friday')}}</label>
                            <span>10 am ~ 10 pm</span>
                        </p>
                        <p class="time" style="padding: 0;margin: 0;">
                        </p>
                    </div>
                </div>
                <div class="map_showpace">
                    <first :is="currentTab" keep-alive></first>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import navbar from './Common/Navbar.vue'
    import Signature from '../lib/Signature'
    import StoreHK from './ContactUs/map/StoreHK.vue'
    import StoreMal from  './ContactUs/map/StoreMal.vue'

    export default {
        data () {
            return {
                shop: {},
                currentTab: 'StoreHK',  // currentTab用于标识当前触发的子组件,
                id:2
            }
        },
        components: {
            navbar,
            StoreHK,
            StoreMal
        },
        methods: {
            getstoredetail () {
                let self = this
                const module = 'offline_detail'
                let data = {}
                data.id = this.$route.query.id
                data.lang = this.$i18n.locale
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                self.$http.get(process.env.BASEURL + module, {params:data}).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        console.log(resp.data)
                        self.shop = resp.data.data
                    }
                })
            },
            ChangeMap(){
                this.id = this.$route.query.id
                console.log(this.id);
                if(this.id == 1){
                    this.currentTab = 'StoreMal'
                }else if (this.id == 2){
                    this.currentTab = 'StoreHK'
                }
            }
        },
        created () {
            //获取店面详情
            this.getstoredetail()

            //判断店面切换地图
            this.ChangeMap()
        }
    }
</script>
<style scoped lang="scss">
    @import "../scss/common";

    .shop {
        border-top: $nav-height solid transparent;
        max-width: $body-width;
        margin: 0 auto;
        margin-bottom: 200px;
        h1 {
            font-size: 40px;
            color: #1F2D3D;
            font-weight: 500;
            text-transform: uppercase;
            margin: 40px 0px;
        }

        .shop-map {
            width: 100%;
            position: relative;
            box-shadow: 0 -5px 10px 5px rgba(153, 169, 191, 0.40);
            display: flex;
            .shop-desc{
                width: 30%;
                .banner{
                    margin: 10% 0;
                }
                .address{
                    text-align: left;
                    padding:0 5%;
                }
                h3,p{
                    /*font-family: PingFangSC-Medium;*/
                    font-size: 16px;
                    color: #1F2D3D;
                    letter-spacing: 0;
                    line-height: 22px;
                    font-weight: 500;
                    margin: 10px 0;
                }
            }
            .map_showpace{
                width: 70%;
                height: 533px;
            }
            .business-hours {
                text-transform: uppercase;
                text-align: left;
                padding:0 5%;
            }
        }
        @media screen and (max-width: 768px) {
            .shop-map{
                box-shadow:none;
                display: block;
                .shop-desc{
                    width: 100%;
                    padding: 10px 0;
                }
                .map_showpace{
                    width: 90%;
                    margin: 10px auto;

                }
            }

        }
        @media screen and (max-width: 414px) {
            h1{
                font-size: 30px;
                margin-bottom: 0;
                margin-top: 10px;
            }
            .shop-map{
                .map_showpace{
                    height: 300px;
                }
                .shop-desc{
                    .banner{
                        margin: 20px 0;
                    }
                    .address,.business-hours{
                        padding: 0 10%;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Shop.vue?e475b222